module.exports = __webpack_public_path__ + "img/VaultSuit.d053aea6.gif";